export const REGISTRY_NEWSLETTER_LEGAL_CONFIRMATION_LABEL_KEYS = {
	checkbox: 'subscribe.legal.checkbox',
	body: 'subscribe.legal.bodycopy',
	title: 'subscribe.legal.title',
}
